import styles from '../en-us.module.css'
import React from 'react';

function EmersonHeader() {
    return (
        <div className="EmersonHeader">
            <div className={styles["cm-row"]}>
                <header className={[styles["global-header"], styles["navbar"], styles["navbar-fixed-top"]].join(' ')}>
                    <nav className={styles["utility-nav"]}>
                        <div className={styles["padded-container"]}>
                            <div className={[styles["hidden-xs"], styles["hidden-sm"]].join(' ')}>
                                <ul className={styles["horizontal-list"]}>
                                <li><a href="https://www.emerson.com/es-es/about-us">Quiénes somos</a></li>
                            {/* <li><a href="https://www.emerson.com/en-us/investors">Investors</a></li>  */}
                            <li><a href="https://www.emerson.com/es-es/careers">Empleos</a></li>
                            <li><a href="https://www.emerson.com/es-es/contact-us">Contáctenos</a></li>
                            <li><a href="https://www.emerson.com/es-es/news">Noticias y eventos</a></li>
                            <li><a href="https://www.emerson.com/catalog/LogonForm?locale=es-es&myAcctMain=1&catalogId=20051&storeId=20151&langId=-5">Ingresar a MyEmerson</a></li>
                            <li>español</li> 
                                </ul>
                            </div>
                        </div>
                    </nav>
                    <nav className={styles["main-header"]} style={{height: "64px" + " !important"}}>
                        <div className={styles["main-header-content"]}>
                            <div className={styles["navbar-header"]}>
                                <div className={[styles["navbar-brand"], styles["emerson-logo-box"]].join(' ')} style={{width: 0}}>
                                    <a href="https://www.emerson.com/en-us" title="" className={styles["emerson-logo__link"]}>
                                        <div className={styles["emerson-logo__image-box"]} 
                                        // style={{height: 64}}
                                        >
                                            <img id="emersonlogo" className={styles["cm-image emerson-logo__image"]} src="images/emerson-logo-compressed--data-5576584.png" alt="Emerson Logo" title=""/>
                                        </div>
                                        <span className={styles["cm-visuallyhidden"]}></span>
                                    </a>
                                </div>
                            </div>
                            <ul className={[styles["main-nav"],styles["list-unstyled"]].join(' ')} id="main-nav" style={{paddingLeft: 50 + " !important"}}>
                                <li><a className=""  href="https://www.emerson.com/es-es/automation-solutions" style={
                                    {
                                        fontWeight: 'bold',
                                        letterSpacing: 0.12 + 'em',
                                        fontSize: .85 + 'em'
                                    }
                                }
                                >SOLUCIONES DE AUTOMATIZACIÓN</a></li>
                                <li><a className="" href="https://www.emerson.com/es-es/commercial-residential-solutions" style={
                                    {
                                        fontWeight: 'bold',
                                        letterSpacing: 0.12 + 'em',
                                        fontSize: .85 + 'em'
                                    }
                                }
                                >SOLUCIONES COMERCIALES Y RESIDENCIALES</a></li>
                            </ul>
                            <div></div>
                        </div>
                    </nav>
                </header>
            </div>
        </div>
    );
  }

export default EmersonHeader